<template>
  <div class="intro-app">
    <app-header @on-click="goBack" :opacity="true" class="packages-head" :title="$t('home.download_app')"/>
    <div class="intro-app-content">
        <div v-html="intorAppContent"></div>
        <div class="btn-box" :class="isBtnFixed ? 'btnFixed' : '' " ref="btnBox">
            <van-button class="downLoadBtn" round block type="info" @click="downLoad()">
                <i class="fa-solid fa-download"></i>
                {{ $t('home.download_app') }}
            </van-button>
        </div>
    </div>
  </div>
</template>

<script>
import { Sticky } from 'vant';
import AppAndtips from '@/data/appAndtips.js';
import cookie from '../../utils/cookie';
export default {
    name: "IntroAPP",
    components:{
        vanSticky: Sticky,
    },
    data() {
        return {
            isBtnFixed: false,
            intorAppContent: '',
        }
    },
    mounted() {
        this.getContent();
    },
    methods: {
        goBack() {
            this.$router.go(-1);
        },
        setBtnStyle(){
            let allHeight = document.querySelector('.intro-app').offsetHeight;
            let btnHeight = this.$refs.btnBox.offsetHeight;
            let btnTop = this.$refs.btnBox?.offsetTop;
            if(allHeight <= btnHeight + btnTop + 20){
                this.isBtnFixed = true;
            } else {
                this.isBtnFixed = false;
            }
        },
        // 获取APP文案
        getContent() {
            AppAndtips.getConfig('appTips-config.json').then(d => {
                let lang = cookie.getCookie('langType') || 'en-US';
                this.intorAppContent = d.intorAppContent?.[lang];
                if(!d.intorAppContent?.[lang] && d.intorAppContent?.['en-US']){
                    this.intorAppContent = d.intorAppContent?.['en-US'];
                }

                this.$nextTick(() => {
                    this.setBtnStyle();                    
                })
            })
        },
        downLoad(){
            window.open('https://mph5.ucloudlink.com/?uuid=4fb9b86a-3604-4cd8-80ac-9d3f0d419fa2&lang=zh-CN', '_blank');
        },
    }
}
</script>

<style lang="less" scoped>
.intro-app {
    height: 100vh;
    height: 100dvh;
    max-height: 100vh;
    max-height: 100dvh;
    overflow: auto;
    background: linear-gradient(135deg, rgba(67, 97, 238,0.20), transparent);
    ::v-deep {
        .maya-app-header.opacity .van-icon-arrow-left {
            color: #333;
        }
        .maya-app-header.opacity .title {
            color: #333;
        }
    }
    .intro-app-content {
        padding: 0 10px;
        font-family: 'Times New Roman', Times, serif;
        font-size: 14px;
        ::v-deep {
            .title {
                color: #333;
                font-weight: 600;
                font-size: 18px;
                text-align: center;
                margin-bottom: 20px;
            }
            .subtitle {
                color: #aaa;
                font-size: 10px;
                text-indent: 2em;
                margin-bottom: 5px;
            }
            .item-content {
                // display: list-item;
                // list-style: disc inside;
                // text-indent: 1em;
                margin-top: 10px;
                margin-bottom: 10px;
                background-color: #ffffff7d;
                padding: 5px 2px;
                border-radius: 5px;
                box-shadow: 2px 2px 5px rgba(0, 0, 0, 0.1);
                min-height: 50px;
                display: flex;
                align-items: center;
                &::before {
                    content: "•";  /* 圆点Unicode字符 */
                    font-size: 16px;
                    display: inline-block;
                    // width: 1em;  /* 控制圆点间距 */
                    margin-left: 6px;  /* 悬挂缩进 */
                    margin-right: 6px;
                    position: relative;
                    // left: -0.5em;  /* 微调位置 */
                    color: #333;  /* 圆点颜色 */
                }
            }
        }
    }
    .downLoadBtn{
        background: #4361ee;
        border-radius: 24px;
        width: 180px;
        height: 32px;
        line-height: 32px;
        border: none;
        color: #fff;
        font-size: 12px;
        margin: auto;
        margin-top: 20px;
    }
    .btnFixed {
        position: fixed;
        left: 0;
        right: 0;
        bottom: 0;
        background-color: #fff;
        padding: 15px 0 15px;
        box-shadow: 0px -2px 4px 0 rgba(0, 0, 0, 0.1);
        .downLoadBtn{ 
            margin-top: unset;
        }
    }
}
</style>